import ForgotPasswordConfig from './forgot-password.config';
import ForgotPasswordUsersController from './forgot-password.users.controller';
import ForgotEmailUsersController from './forgot-email.users.controller';
import PasswordResetUsersController from './password-reset.users.controller';
import PasswordResetSentUsersController from './password-reset-sent.users.controller';
import PasswordResetSent2UsersController from './password-reset-sent2.users.controller';
import NewPasswordUsersController from './new-password.users.controller';
import PasswordChangedUsersController from './password-changed.users.controller';
import ChooseAccountUsersController from './choose-account.users.controller';
import AccountConfirmationUsersController from './account-confirmation.users.controller';
import RecoveryAccountLoginUsersController from './recovery-account-login.users.controller';
import NoAccountUsersController from './no-account.users.controller';

let fpModule = angular.module('ff.users.forgot-password', []);

fpModule.config(ForgotPasswordConfig);
fpModule.controller('ForgotPasswordUsersController', ForgotPasswordUsersController);
fpModule.controller('ForgotEmailUsersController', ForgotEmailUsersController);
fpModule.controller('PasswordResetUsersController', PasswordResetUsersController);
fpModule.controller('PasswordResetSentUsersController', PasswordResetSentUsersController);
fpModule.controller('PasswordResetSent2UsersController', PasswordResetSent2UsersController);
fpModule.controller('NewPasswordUsersController', NewPasswordUsersController);
fpModule.controller('PasswordChangedUsersController', PasswordChangedUsersController);
fpModule.controller('ChooseAccountUsersController', ChooseAccountUsersController);
fpModule.controller('AccountConfirmationUsersController', AccountConfirmationUsersController);
fpModule.controller('RecoveryAccountLoginUsersController', RecoveryAccountLoginUsersController);
fpModule.controller('NoAccountUsersController', NoAccountUsersController);

export default fpModule = fpModule.name



// WEBPACK FOOTER //
// ./src/users/forgot-password/forgot-password.module.js